import { Pipe, PipeTransform } from '@angular/core';

/** Siglas que continuam em maiúsculas depois da conversão. */
const SIGLAS = new Set([
    'IPTU', 'ITBI', 'ISS', 'ISSQN', 'ICMS', 'REFIS', 'CND', 'CNPJ', 'CPF', 'RG', 'CNH', 'CEP', 'UF', 'MEI', 'ME', 'EPP',
    'LTDA', 'DAM', 'DTI', 'PGM', 'TCE', 'MP', 'SUS', 'INSS', 'FGTS', 'PIS', 'PASEP', 'FMPS', 'SEFIN', 'SESA', 'SEPLAG',
    'SEDUC', 'SEMURB', 'SEAD', 'SGA', 'CE', 'ONG', 'TI',
]);

/** Palavras que ficam em minúsculas no meio de um nome próprio. */
const CONECTIVOS = new Set(['a', 'o', 'as', 'os', 'à', 'às', 'ao', 'aos', 'de', 'da', 'do', 'das', 'dos', 'e', 'em', 'na', 'no', 'nas', 'nos', 'para', 'por', 'com', 'sem']);

const PALAVRA = /[A-Za-zÀ-ÖØ-öø-ÿ0-9]+/g;
const ROMANO = /^(I|II|III|IV|V|VI|VII|VIII|IX|X)$/;

/**
 * Assuntos e órgãos vêm do cadastro em caixa alta ("LICENÇA PATERNIDADE"). Nas telas
 * do cidadão eles aparecem como se escreve: assunto como frase ("Licença paternidade")
 * e órgão como nome próprio ("Secretaria de Saúde"), mantendo siglas e numerais.
 *
 * Uso: {{ assunto | rqTitle }} ou {{ orgao | rqTitle: 'nome' }}.
 */
@Pipe({ name: 'rqTitle' })
export class RqTitlePipe implements PipeTransform {
    transform(value: string | null | undefined, mode: 'frase' | 'nome' = 'frase'): string {
        if (!value) return '';

        const texto = String(value).trim().replace(/\s+/g, ' ');

        // Já escrito à mão, com minúsculas: respeita como veio.
        if (texto !== texto.toUpperCase()) return texto;

        let primeira = true;

        return texto.replace(PALAVRA, (palavra) => {
            const maiuscula = palavra.toUpperCase();
            const minuscula = palavra.toLowerCase();
            const inicio = primeira;
            primeira = false;

            if (SIGLAS.has(maiuscula) || ROMANO.test(maiuscula)) return maiuscula;
            if (inicio) return capitalizar(minuscula);
            if (mode === 'nome' && !CONECTIVOS.has(minuscula)) return capitalizar(minuscula);

            return minuscula;
        });
    }
}

function capitalizar(palavra: string): string {
    return palavra.charAt(0).toUpperCase() + palavra.slice(1);
}
